import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './styles/Utilities.scss';
import CustomTheme from './features/theme/CustomTheme';

function initJointCustomers() {
  const menuEls = document.getElementsByClassName('joint-customers-menu');
  const accountEls = document.getElementsByClassName('joint-customers-account');
  const loginEls = document.getElementsByClassName('joint-customers-login');
  if (menuEls && menuEls.length > 0) {
    Array.from(menuEls).forEach((menuEl, index) => {
      const root = createRoot(menuEl);
      root.render(
        <React.StrictMode>
            <CustomTheme>
              <App />
            </CustomTheme>
        </React.StrictMode>
      );
    })
  }

  if (loginEls && loginEls.length > 0) {
    Array.from(loginEls).forEach((loginEl, index) => {
      const root = createRoot(loginEl);
      root.render(
        <React.StrictMode>
            <CustomTheme>
              <App page="login" />
            </CustomTheme>
        </React.StrictMode>
      );
    })
  }

  if (accountEls && accountEls.length > 0) {
    Array.from(accountEls).forEach((accountEl, index) => {
      const root = createRoot(accountEl);
      root.render(
        <React.StrictMode>
            <CustomTheme>
              <App page="account" />
            </CustomTheme>
        </React.StrictMode>
      );
    })
  }


}

initJointCustomers();

